import dayjs from 'dayjs';

import { JobdomPost } from '~types/jobdom';

import JobdomItem from '../JobdomItem';
import * as S from './style';

interface Props {
  posts: JobdomPost[];
  PK_NM_HASH: string;
  postCount: number;
  companyName: string;
  companyId: number;
  onClickReaction: () => void;
}

export default function JobdomContainer({
  posts,
  postCount,
  PK_NM_HASH,
  companyName,
  companyId,
  onClickReaction,
}: Props) {
  return (
    <S.StyledJobdomContainer>
      {posts.map(
        ({ id, name, subject, viewCount, likesCount, unlikesCount, commentCount, createdAt }) => (
          <JobdomItem
            key={id}
            contentId={id}
            companyId={companyId}
            PK_NM_HASH={PK_NM_HASH}
            companyName={companyName}
            subject={subject}
            viewCount={viewCount}
            likesCount={likesCount}
            unlikesCount={unlikesCount}
            author={name}
            commentCount={commentCount}
            createdAt={dayjs(createdAt).format('YYYY-MM-DD')}
            onClickReaction={onClickReaction}
          />
        ),
      )}
      {postCount > 3 && <S.Shadow />}
    </S.StyledJobdomContainer>
  );
}
